'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypeCol = function TypeCol(_ref) {
  var paidPartnership = _ref.paidPartnership,
      brand = _ref.brand;

  if (paidPartnership) {
    return _react2.default.createElement(_semanticUiReact.Popup, {
      trigger: _react2.default.createElement(_semanticUiReact.Label, { icon: 'checkmark', basic: true, color: 'green', content: 'PP' }),
      content: 'Paid partnership with ' + brand
    });
  }
  return _react2.default.createElement(
    'div',
    null,
    'Ad'
  );
};

var latestPostDate = function latestPostDate(posts) {
  if (posts.length > 0) {
    var sortedPosts = _lodash2.default.orderBy(posts, ['publishedDate'], ['desc']);
    return sortedPosts[0].publishedDate;
  }
  return '-';
};

var BrandMentionsTable = function BrandMentionsTable(_ref2) {
  var data = _ref2.data,
      clickHandler = _ref2.clickHandler;
  return _react2.default.createElement(
    _semanticUiReact.Table,
    {
      textAlign: 'center',
      celled: true
    },
    _react2.default.createElement(
      _semanticUiReact.Table.Header,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Brand'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          '# posts'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Published Date'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Type'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Avg. Engs.'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Engs. Rate'
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Body,
      null,
      _lodash2.default.map(data.data, function (item) {
        var brand = item.brand,
            url = item.url,
            engagementFigures = item.engagementFigures;

        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            brand,
            ' ',
            _react2.default.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: url },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', color: 'grey' })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            engagementFigures.numberOfPosts,
            _react2.default.createElement(
              'a',
              {
                style: { cursor: 'pointer', color: '#20c49e' },
                onClick: function onClick() {
                  return clickHandler(item);
                }
              },
              ' (click to view)'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _moment2.default)(latestPostDate(engagementFigures.brandPosts)).format('MMMM Do YYYY')
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(TypeCol, {
              brand: brand,
              paidPartnership: engagementFigures.paidPartnership
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(engagementFigures.engagementAverage.toFixed(0))
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            !engagementFigures.engagementRate && _react2.default.createElement(_semanticUiReact.Popup, {
              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock outline', color: 'orange' }),
              content: 'Calculating Engs. Rate'
            }),
            engagementFigures.engagementRate && engagementFigures.engagementRate.toFixed(2) + '%'
          )
        );
      })
    )
  );
};

BrandMentionsTable.propTypes = {
  data: _propTypes2.default.object.isRequired,
  clickHandler: _propTypes2.default.func.isRequired
};

exports.default = BrandMentionsTable;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/brand-mentions-table/index.js
 ** module id = 2549
 ** module chunks = 0
 **/